// The customer portal's tab title (sentinelui's automation asserts it after the Knowledge Center link);
// the staff desk keeps index.html's title.
import { useEffect } from "react";

export const PORTAL_TITLE = "Kajeet Support Access";

/** Portal title while the calling portal shell is mounted; restores the previous title after. */
export function usePortalTitle(): void {
  useEffect(() => {
    const before = document.title;
    document.title = PORTAL_TITLE;
    return () => {
      document.title = before;
    };
  }, []);
}
